<div class="region-country-field">
  <ng-container *ngIf="textInputMode; else dropdownTemplate">
    <input
      pInputText
      (ngModelChange)="onSelectValue($event)"
      [(ngModel)]="selectedValue"
      (blur)="markAsTouched()"
      class="qt-residence-region"
      type="text"
      data-qa="regionCountryField_input"
      [placeholder]="placeholder"
    />
  </ng-container>
  <ng-template #dropdownTemplate>
    <lx-dropdown-side-panel-field
      [filter]="true"
      [options]="regions"
      [title]="title"
      (ngModelChange)="onSelectValue($event)"
      (blurred)="markAsTouched()"
      [(ngModel)]="selectedValue"
      data-qa="regionCountryField_selector"
      filterBy="name"
      optionLabel="name"
      optionValue="code"
      [placeholder]="placeholder"
    >
    </lx-dropdown-side-panel-field>
  </ng-template>
</div>
